// EN content — working defaults for the current website.
// Unverified values are intentionally usable copy rather than visible placeholders.
// Every assumption and its confidence level is recorded in
// docs/site-blueprint/04-assumptions-register.md for the owner to replace.
const ASSUMED = {
  'ABN/ACN': '(ABN 98 662 905 400; ACN 662 905 400)',
  'data controller and ABN/ACN': '(ABN 98 662 905 400; ACN 662 905 400) is responsible for the personal information handled through this website',
  'final company category and AFS / licensing boundary': 'Adelaide-based development and investment company. We do not raise funds from the public or provide personal financial product advice to retail clients.',
  'final company category and geography': 'Adelaide-based development and investment company focused on South Australia, with selected Australian business and innovation opportunities considered where there is a clear built-environment fit.',
  'investment area / postcode / radius': 'Metropolitan Adelaide and selected South Australian growth areas, generally within practical reach of Adelaide.',
  'allowed use / asset types': 'Residential, mixed-use and selected small commercial or industrial development where demand and planning pathways can be evidenced.',
  'accepted stage — uncontrolled / controlled land / pre-planning / in approval / under construction': 'Owner-controlled or contracted sites from pre-planning through approval; construction-stage opportunities only selectively.',
  'typical scale range and basis': 'Working range: approximately A$2m–A$30m total development value, assessed case by case.',
  'title and control requirements': 'The submitter must own the site, control it under contract, or hold written authority from the owner.',
  'planning status requirements': 'Approval is not required at first contact, but the planning pathway, key overlays and material constraints must be identifiable.',
  'expected timeline': 'A credible decision or planning pathway within 24 months and a delivery horizon that can be defined at assessment.',
  'out-of-area exclusion wording': 'Sites outside South Australia are not a current property focus unless there is a specific strategic reason and local delivery capability.',
  'own capital / co-investment structure and conditions': 'Selected opportunities using Cyberate capital or a specifically documented co-investment structure, subject to diligence, approvals and legal documents.',
  'JV structure and conditions': 'A project-specific joint venture with clear capital commitments, governance, decision rights, risk allocation and exit terms.',
  'acceptance of agents / advisers': 'Authorised agents and advisers may submit on an owner’s behalf.',
  'intermediary policy': 'The intermediary must disclose their authority and any fee or interest connected with the opportunity.',
  'whether this pillar is operational, geography and deal type': 'We are actively open to private Australian equity and strategic partnership discussions, with priority given to South Australian businesses and opportunities where we can contribute directly.',
  'client concentration and quality requirements': 'A credible, referenceable client base with concentration risks identified and manageable; no single hard cap is applied at first screen.',
  'team / key-technology dependency requirements': 'An accountable management team, documented delivery processes and no unmanaged reliance on one individual, licence or system.',
  'project concentration and volatility tolerance': 'Backlog, margins and exposure to any single project must be visible and resilient under a downside case.',
  'accepted business stage': 'Established operating businesses with recurring or repeatable revenue; pre-revenue concepts and distressed turnarounds are not the current focus.',
  'revenue / profit / geography / ownership thresholds': 'Working screen: Australian private businesses with roughly A$2m–A$30m annual revenue and a path to sustainable positive earnings.',
  'equity preference — minority / majority / control': 'Strategic minority positions are preferred; control positions may be considered where both sides agree and the operating case supports it.',
  'board / key-decision participation': 'A board seat or observer right and agreed approval rights for material decisions are normally expected where capital is invested.',
  'time horizon': 'A medium- to long-term working horizon, generally three to seven years, with liquidity expectations agreed at the outset.',
  'structure preference': 'Equity or project-specific joint venture structures are preferred; standalone lending is not a current focus.',
  'team history / output evidence per topic': 'The current team brings data, property-development, commercial, business-development and marketing responsibilities; detailed track-record evidence is provided during direct diligence rather than claimed on this site.',
  'whether a standard NDA process exists': 'A mutual NDA may be agreed after the first non-sensitive screen and before detailed financial, customer or technical diligence.',
  'control preference': 'Strategic minority participation is the default working assumption; control is considered only where expressly agreed.',
  'intermediary / commission policy': 'No adviser, broker or referral fee is payable unless it is agreed in writing before an introduction and disclosed to relevant parties.',
  'deal-type boundary': 'We consider equity investment, project joint ventures and strategic partnerships; we do not offer general business loans.',
  'innovation pillar mandate, stage, geography': 'We consider Australia- and New Zealand-based built-environment technologies that are pilot-ready, have pilot evidence or have paying customers; idea-only concepts are not the current focus.',
  'exclusion list finalisation': 'Consumer apps, general SaaS, speculative tokens, unvalidated AI claims and technologies without a credible deployment pathway are out of scope.',
  'investment threshold': 'Eligible for selective consideration where deployment evidence, customer demand and a credible capital plan are present.',
  'investment criteria and capital structure': 'A built-environment problem, deployable product, credible team, evidence of adoption and a project-specific equity structure that passes commercial, technical and legal diligence.',
  'referrable parties and authorisation': 'Introductions are limited to organisations with which we have a current, relevant relationship, and only with the parties’ consent.',
  'feedback depth and recipient': 'We aim to give the submitting contact a high-level fit or no-fit reason, but do not provide detailed technical, legal or investment advice on declined submissions.',
  'NDA process': 'A mutual NDA can be considered after initial fit is established and before sensitive diligence begins.',
  'whether the method operates as an established capability': 'This is the decision framework adopted for new opportunities; public deal-by-deal evidence is not yet published.',
  'Realise definition and meaning': 'Realise means agreeing how value may be crystallised — for example project completion, refinance, sale, distributions or another negotiated liquidity event — without guaranteeing that event.',
  'external network relationships': 'No standing partner network is claimed publicly; external specialists are identified and their role disclosed for each opportunity.',
  'publicly available evidence for each capability': 'local contact and an articulated assessment framework are public; capital, team track record, partner relationships and execution evidence remain subject to direct diligence.',
  'control approach': 'Obtain independent planning advice, test downside scenarios, make material approvals conditions precedent and stop where the pathway remains unresolved.',
  'conflict policy and approval authority': 'Disclose the interest, exclude the conflicted person from the decision, and require approval from a non-conflicted director with legal review where needed.',
  'governance / conflict policy finalisation': 'This disclosure, recusal and independent-approval approach is the working governance rule for new opportunities.',
  'principal place of business': '5/15 Field St, Adelaide SA 5000',
  'registered office': '5/15 Field St, Adelaide SA 5000',
  'AFS licence / authorised representative / exemption / not conducting licensable activity — precise wording': 'The company does not raise funds from the public or provide personal financial product advice to retail clients. Any investment participation is considered for a specific opportunity and is subject to legal and regulatory review.',
  'licence / authorisation / exemption / non-licensable activity — precise statement': 'does not raise funds from the public or provide personal financial product advice to retail clients; any investment participation is specific to an opportunity and subject to legal and regulatory review',
  'verification date': '14 August 2026',
  'ASIC / ABR official register link': 'Search the ASIC and Australian Business Register public registers using “Cyberate Investments Pty Ltd”.',
  'verifiable company milestones and sources': 'Current public materials establish an Adelaide office, a data-led property and commercial assessment focus, and the present three-pillar investment direction. No historical transaction milestones are claimed without supporting records.',
  'roles, history, qualifications and photo consent': 'Roles below follow the current website. Detailed qualifications, external verification links and photo permissions are not claimed unless supplied by the individual.',
  'LinkedIn / professional registration': 'Verification available directly from the company',
  'DDDI entity relationships, brand rights and responsibility boundaries': 'Cyberate Investments describes itself as the investment and commercial decision-intelligence entity of the DDDI Group and uses the DDDI framework as an analytical method. Any engagement is contracted with the entity named in the relevant agreement; no other group entity is assumed to be responsible unless that agreement says so.',
  'business hours and appointment requirements': 'Monday–Friday, 9:00 am–5:00 pm Adelaide time. Meetings and office visits are by appointment.',
  'whether walk-ins are accepted or by appointment only': 'Office visits are by appointment only. Please call or email before travelling.',
  'accessibility and parking information': 'Contact us before your visit so we can confirm building access and the most suitable nearby parking or public-transport option.',
  'whether phone is collected': 'Optional; provide it only if you would like a call.',
  'response method and timing; no SLA unless confirmed': 'We aim to respond by email or your requested channel within two business days.',
  'whether required': 'Optional; provide it if phone is your preferred contact method.',
  'allowed formats and size limits, upload storage and access control': 'Direct file upload is not enabled. Provide a non-sensitive link or short description; we will arrange a controlled channel if detailed files are needed.',
  'response timing and owner': 'The opportunity review team aims to acknowledge the submission by email within two business days and provide an initial fit response within five business days.',
  'date': '14 August 2026',
  'legal review and finalisation': 'This version reflects the current website and working operating assumptions and should be reviewed by Australian counsel before being treated as final legal advice.',
  'log / analytics data (if any)': 'IP address, browser and device information, requested pages, referrer, timestamps, server logs and Google advertising/analytics identifiers where those scripts operate.',
  'source': 'Your browser or device, our web server, Google Tag Manager/Google Ads and hCaptcha.',
  'required': 'Security and server logs are necessary; advertising or analytics storage should be optional where consent is required.',
  'handling approach': 'We restrict access, avoid using it for a new purpose, and securely delete or de-identify it when it is not required and no legal retention duty applies.',
  'legal basis': 'Your request or consent, our legitimate business functions, and applicable legal obligations.',
  'whether accurate': 'No marketing list or significant automated decision-making is currently implemented in this website code.',
  'email / hosting / form provider': 'The DDDI contact API and its database, email and hosting providers',
  'captcha provider': 'hCaptcha (Intuition Machines)',
  'data': 'Only contact, submission, device or security information needed for the stated purpose.',
  'cross-border': 'Australia and other locations in which the relevant cloud or security provider processes data.',
  'safeguards': 'Need-to-know access, provider terms and security controls, and contractual review before sensitive data is shared.',
  'period or decision criteria': 'Up to 24 months after the last interaction, unless required for a live matter or by law.',
  'period': 'Up to five years after the last interaction; non-progressing uploaded material should be deleted within 24 months unless legal retention applies.',
  'actual organisational / technical measures': 'HTTPS transport, server-side form submission without client-side database credentials, hCaptcha, restricted administrative access, provider security controls and retention/deletion procedures.',
  'cookie / storage categories from an actual scan': 'The current site loads essential browser storage, hCaptcha, Google Tag Manager and Google Ads/remarketing technology. Non-essential advertising or analytics technology should run only after any required consent, and users should be able to change that choice.',
  'dedicated mailbox or contact person': 'info@cyberate.investments (subject: Privacy enquiry)',
  'internal complaint process and applicable regulator (e.g. OAIC)': 'Email us with “Privacy complaint” in the subject. We will acknowledge and investigate the complaint, request any information needed, and provide an outcome. If it is not resolved, you may contact the Office of the Australian Information Commissioner at oaic.gov.au.',
  'acceptance mechanism consistent with the actual UI': 'No account or paid service is created by browsing; form users separately confirm the statements shown at submission.',
  'actual asset rights': 'Only company-created or properly licensed assets should be published; third-party marks and stock material remain subject to their owners’ licences.',
  'licence scope confirmed by counsel': 'This limited licence is non-exclusive and only permits internal review, due diligence and communication about the submitted opportunity; it does not transfer ownership.',
  'governing law confirmation': 'The parties submit to the courts of South Australia and courts entitled to hear appeals from them, subject to rights that cannot lawfully be excluded.',
};

const assumed = (label) => ASSUMED[label] || 'Please contact Cyberate Investments for details.';

export const entity = {
  name: 'Cyberate Investments Pty Ltd',
  abn: '98 662 905 400',
  acn: '662 905 400',
  address: '5/15 Field St, Adelaide SA 5000',
  phone: '+61 8 7110 0111',
  phoneHref: 'tel:+61871100111',
  email: 'info@cyberate.investments',
  emailHref: 'mailto:info@cyberate.investments',
};

const en = {
  entity,

  nav: {
    aria: 'Main navigation',
    home: 'Home',
    whatWeInvest: 'What We Invest In',
    howWeInvest: 'How We Invest',
    about: 'About',
    contact: 'Contact',
    submitCta: 'Submit an opportunity',
    pillars: {
      property: { label: 'Property Development', desc: 'Land and development opportunities.' },
      built: { label: 'Built Environment Investments', desc: 'Businesses that build and shape the built environment.' },
      innovation: { label: 'Innovation & Ventures', desc: 'PropTech, construction tech, AI and sustainable construction.' },
    },
    language: { en: 'EN', zh: '中文', current: 'English', toggle: '中文' },
  },

  footer: {
    entityTitle: 'Entity',
    navTitle: 'Navigation',
    legalTitle: 'Legal',
    ctaTitle: 'Submit an opportunity',
    ackTitle: 'Acknowledgement of Country',
    country:
      'Cyberate Investments acknowledges the Traditional Owners and Custodians of the lands throughout Australia. We pay our respects to Elders both past and present and honour the enduring cultural, spiritual, and educational practices of Aboriginal and Torres Strait Islander peoples.',
    copyright: '© {{year}} Cyberate Investments Pty Ltd. All rights reserved.',
  },

  cta: {
    submit: 'Submit an opportunity',
    submitCommit:
      'Tell us the type, location and stage of your opportunity. We respond with next steps, not a guarantee of funding.',
    discuss: 'Discuss a partnership',
    discussCommit: 'For a general or strategic conversation, not a specific deal.',
    explore: 'Explore what we invest in',
    seeCriteria: 'See the criteria',
    seeApproach: 'See the full approach',
    backToHome: 'Back to home',
  },

  compliance: {
    short:
      'Cyberate Investments Pty Ltd is an Adelaide-based development and investment company. This website provides general information only. It is not financial product advice, an offer of any financial product, or a solicitation to invest. Every opportunity is subject to assessment, and participation and terms are agreed individually. Past performance, where referenced, does not guarantee future results.',
    full:
      'Cyberate Investments Pty Ltd is an Adelaide-based development and investment company. Nothing on this website constitutes financial product advice, a recommendation, an offer or invitation to acquire any financial product, or a promise of any return or outcome. We describe opportunities we focus on and the role we may play, but participation, capital, structure and terms are only ever agreed for a specific opportunity after assessment and, where required, legal and regulatory review. We do not engage in public fundraising and do not provide personal financial advice to retail clients. Any figure on this site states its scope, basis, period and source; historical information does not guarantee future results.',
    companyCategory: assumed('final company category and AFS / licensing boundary'),
  },

  home: {
    meta: {
      title: 'Cyberate Investments — Adelaide Property Development & Investment Company',
      description:
        'Cyberate Investments is an Adelaide-based development and investment company focused on property, built-environment businesses and enabling innovation. We assess selected opportunities and participate where appropriate.',
    },
    hero: {
      eyebrow: 'Adelaide · Built environment',
      h1: 'We invest in property, businesses and ideas that shape the built environment.',
      lead:
        'Cyberate Investments is an Adelaide-based development and investment company. We focus on three areas — property development, built-environment businesses and enabling innovation — and we participate only in opportunities that clear a defined assessment.',
      boundary:
        'Every opportunity is assessed individually. Participation and terms are agreed for each engagement; nothing here is an offer of a financial product or a promise of returns.',
    },
    pillars: {
      eyebrow: 'What we invest in',
      h2: 'Three areas we focus on',
      lead: 'Each area has its own criteria. Choose the one that matches your situation — you can check the details before you contact us.',
      boundary: 'These are areas we focus on, not a record of past deals.',
      items: [
        {
          title: 'Property Development',
          desc: 'Land and development opportunities in South Australia.',
          question: 'Do you have a site or project and want to know if it fits?',
          cta: 'See property criteria',
          to: '/property-development',
        },
        {
          title: 'Built Environment Investments',
          desc: 'Building, engineering, design, supply-chain and professional-services businesses.',
          question: 'Are you an owner considering growth, succession or a strategic partner?',
          cta: 'See business criteria',
          to: '/built-environment-investments',
        },
        {
          title: 'Innovation & Ventures',
          desc: 'PropTech, construction tech, AI and sustainable-construction teams.',
          question: 'Does your technology solve a measurable built-environment problem?',
          cta: 'See innovation criteria',
          to: '/innovation-ventures',
        },
      ],
    },
    stance: {
      eyebrow: 'Our stance',
      h2: 'How we decide what to pursue',
      lead: 'We would rather pass on an opportunity than misstate what we can do with it.',
      principles: [
        { title: 'Selective in what we pursue.', body: 'We define criteria before we look at an opportunity, and we stop when evidence falls short.' },
        { title: 'Active in how we create value.', body: 'Where we participate, we bring more than a decision — we bring structure, judgement and execution support appropriate to the role we take.' },
        { title: 'Clear about risk and role.', body: 'We say what we are and are not doing, and we put limits next to every claim.' },
      ],
      cta: 'Read our investment approach',
    },
    role: {
      h2: 'What participation can involve',
      lead: 'Depending on the opportunity and the role we agree to take, our involvement may include one or more of the following.',
      groups: [
        { title: 'Judgement', body: 'Structured assessment of the plan, market, feasibility and the risks that decide whether to proceed.' },
        { title: 'Structure and participation', body: 'The form of involvement — which may include capital, co-investment or support — agreed for the specific opportunity.' },
        { title: 'Execution support', body: 'Planning, project or operating support where it fits the role we take.' },
      ],
      note: 'The detail behind each of these sits in our investment approach, and each capability is stated with its evidence — not as a label.',
      cta: 'See the five capabilities',
    },
    local: {
      eyebrow: 'Adelaide based',
      h2: 'Based in Adelaide, reachable by phone and email',
      boundary: 'Company registration details and any licence or authorisation status are published on our About page.',
      aboutLink: 'See company details',
    },
    preview: {
      eyebrow: 'How we invest',
      h2: 'Five stages, each with an entry and an exit',
      body: 'Identify → Invest → Build → Scale → Realise. Every stage has its own inputs, judgement, our role and the conditions under which we stop.',
      note: 'Not every opportunity proceeds to the next stage, and we do not take every role in every project.',
      cta: 'Read the full approach',
      stages: ['Identify', 'Invest', 'Build', 'Scale', 'Realise'],
    },
    finalCta: {
      h2: 'Have a specific opportunity, or still deciding?',
      body:
        'If you have a site, business or venture, submit it — we will ask only for what we need to make a first assessment. If you are still deciding, review how we invest or contact us with a general question.',
      review: 'Review our approach',
      contact: 'Contact us',
      privacy: 'We collect only what we need for an initial assessment. See our Privacy Policy.',
    },
  },

  property: {
    meta: {
      title: 'Property Development | Cyberate Investments',
      description:
        'How we assess South Australian property development opportunities — location, use, stage, scale, control and planning — and the roles we may take from capital to execution support.',
    },
    hero: {
      eyebrow: 'Property Development',
      h1: 'We assess land and development opportunities in South Australia.',
      lead:
        'If you have a site or a project — and want a first read on whether it fits what we pursue — this page sets out our criteria, our possible roles and what to prepare before you submit.',
      boundary: 'We look at selected opportunities only. Location, use, stage, scale and control all matter, and every opportunity is assessed individually.',
      cta: 'Submit a property opportunity',
      seeCriteria: 'See the criteria',
      roleNote: 'Nothing on this page is an offer of finance or a promise of approval.',
    },
    fit: {
      h2: 'What we look at before you submit',
      lead: 'These are the dimensions we assess. Confirmed thresholds are listed where they exist; anything not yet fixed is marked rather than hidden behind "flexible".',
      rows: [
        { dim: 'Location', what: assumed('investment area / postcode / radius'), why: 'We focus where we can assess market and planning risk ourselves.' },
        { dim: 'Use / asset type', what: assumed('allowed use / asset types'), why: 'Use drives feasibility, buyers and exit.' },
        { dim: 'Stage', what: assumed('accepted stage — uncontrolled / controlled land / pre-planning / in approval / under construction'), why: 'Stage changes what evidence we need.' },
        { dim: 'Scale', what: assumed('typical scale range and basis'), why: 'Scale must fit our participation model.' },
        { dim: 'Control / title', what: assumed('title and control requirements'), why: 'We need to know who can commit the site.' },
        { dim: 'Planning status', what: assumed('planning status requirements'), why: 'Planning risk is a gate, not a footnote.' },
        { dim: 'Timeline', what: assumed('expected timeline'), why: 'Timing affects structure and exit.' },
      ],
      note: 'If most of these are unclear yet, start with what you know — our form asks for the minimum, and "Not known yet" is an accepted answer.',
    },
    notFit: {
      h2: "What we don't take on",
      lead: 'Saying no early saves both sides time. These are out of scope unless our mandate changes.',
      items: [
        { title: 'Personal or retail investment advice', body: 'We do not provide financial advice or manage anyone\u2019s portfolio.' },
        { title: 'Financing guarantees', body: 'We cannot guarantee approval, funding or completion on any project.' },
        { title: 'Opportunities without control or verifiable title', body: 'Without clear title or authority, we cannot assess the commitment.' },
        { title: 'Sites outside our focus area', body: assumed('out-of-area exclusion wording') },
        { title: 'Insufficient information to assess', body: 'A teaser with no location, stage or ownership detail cannot be evaluated.' },
      ],
      boundary: 'The role we can take depends on the opportunity and the legal and regulatory boundary that applies. We will tell you early if we can only offer analysis, not capital.',
      alt: 'Not a fit? A general question can still go to our Contact page.',
    },
    roles: {
      h2: 'Roles we may take',
      lead: 'The role is agreed per opportunity — it is not a package. The table shows what each role means and what it does not mean.',
      rows: [
        { role: 'Capital participation', when: assumed('own capital / co-investment structure and conditions'), responsibility: 'Capital agreed for a specific opportunity after assessment.', notMeaning: 'A commitment to fund, or public fundraising.' },
        { role: 'Co-investment / JV', when: assumed('JV structure and conditions'), responsibility: 'Shared structure with defined decision rights.', notMeaning: 'Silent capital or a guarantee.' },
        { role: 'Development / analysis support', when: 'Feasibility, planning and structuring questions.', responsibility: 'Structured assessment and execution support within an agreed scope.', notMeaning: 'A licence, approval or financing outcome.' },
        { role: 'Project execution support', when: 'Where execution support fits the role.', responsibility: 'Planning and delivery support within agreed responsibility.', notMeaning: '\u201cOne-stop\u201d delivery of every function.' },
      ],
      note: 'Roles are confirmed only after assessment and, where required, legal and regulatory review.',
    },
    assessment: {
      eyebrow: 'Assessment lens',
      h2: 'What we weigh when we assess a development',
      lead: 'We treat planning, market, design, feasibility, capital, delivery and risk as one decision — not a list of separate boxes.',
      rows: [
        { face: 'Planning', input: 'Zone, overlays, consents, conditions.', impact: 'A gate: unresolved planning risk stops the assessment.' },
        { face: 'Market', input: 'Comparable sales and demand data with source and date.', impact: 'Drives use and feasibility assumptions.' },
        { face: 'Design / product', input: 'Site constraints and target buyer or tenant.', impact: 'Determines whether the product is credible.' },
        { face: 'Feasibility', input: 'Cost, revenue and timing assumptions with basis.', impact: 'Tests whether the plan holds under stress.' },
        { face: 'Capital', input: 'Structure, cost and source of capital.', impact: 'Determines whether participation fits our model.' },
        { face: 'Delivery', input: 'Builder, program and delivery track record.', impact: 'Tests whether execution risk is manageable.' },
        { face: 'Risk', input: 'Assumptions, sensitivities and mitigation.', impact: 'Decides go / no-go and what we need to control.' },
      ],
      cta: 'See how this fits our five stages',
    },
    materials: {
      h2: 'What to prepare before you submit',
      lead: 'You do not need a full data room. Start with a short summary; the rest can follow in a secure channel.',
      minimum: [
        'Location and site description',
        'Your title or authority over the site',
        'Current stage (planning, approved, under construction)',
        'Proposed use and scale',
        'Planning status and any consents',
        'Expected timeline',
        'What you are looking for from us (capital, co-investment, assessment, execution support)',
      ],
      later: ['Feasibility model or cost plan', 'Site survey, plans, engineering reports', 'Finance or sales evidence'],
      privacy: 'Do not send identity documents or unrelated personal data in the first step. File uploads, where available, are limited to the formats and sizes stated on the form.',
      cta: 'Start the submission',
    },
    path: {
      h2: 'What happens after you submit',
      lead: 'Four steps, with a clear stopping point at each. No stage here is a commitment to proceed, fund or approve.',
      steps: [
        { title: 'Initial screen', body: 'We check location, use, stage, scale and control against our criteria.', io: 'You provide a summary; we give a first read.' },
        { title: 'Information and assessment', body: 'We request the detail we need and assess planning, market, feasibility and risk.', io: 'You supply documents through a secure channel.' },
        { title: 'Role and terms', body: 'We discuss the role, structure and terms that could apply.', io: 'Both sides decide whether the terms fit.' },
        { title: 'Proceed or stop', body: 'We either move to a formal agreement or stop, with reasons.', io: 'Either party can stop at any stage.' },
      ],
      note: 'Confidentiality agreements, site visits and third-party due diligence are introduced only where the opportunity requires them.',
      cta: 'See the full method',
    },
    faq: {
      h2: 'Common questions before you submit',
      items: [
        { q: 'Do I need planning approval before I submit?', a: 'No. We look at opportunities at different stages. What matters is that you can describe the site, its planning status and what you want from us.' },
        { q: 'Do I need to own the land outright?', a: 'No — but you need authority over it. Tell us whether you own it, have it under contract, or represent someone who does. ' + assumed('acceptance of agents / advisers') },
        { q: 'Do you accept introductions from agents or advisers?', a: 'Yes, where the person submitting has authority to do so. We will ask you to confirm that. ' + assumed('intermediary policy') },
        { q: 'Can you guarantee funding or approval?', a: 'No. We do not guarantee finance, approval, completion or any return. Any role we take is agreed only after assessment.' },
        { q: 'How is my information handled?', a: 'We collect only what we need for a first assessment. See our Privacy Policy for what we collect, why and how long we keep it.' },
      ],
      cta: 'Submit a property opportunity',
      alt: 'Contact us instead',
      siblings: ['Built Environment Investments', 'Innovation & Ventures'],
    },
  },

  built: {
    meta: {
      title: 'Built Environment Investments | Cyberate Investments',
      description:
        'How we approach investments in building, engineering, design, supply-chain and professional-services businesses — the situations, structures and governance we consider.',
    },
    hero: {
      eyebrow: 'Built Environment Investments',
      h1: 'We look at businesses that build and shape the built environment.',
      lead:
        'This is about companies — not just property projects. If you own or run a building, engineering, design, supply-chain or professional-services business and are considering growth, succession or a strategic partner, this page explains how we think and what we would need.',
      boundary: 'We seek to evaluate selected opportunities. This is a stated focus, not a record of completed acquisitions or a national network. ' + assumed('whether this pillar is operational, geography and deal type'),
      cta: 'Submit a business opportunity',
      seeCriteria: 'See what we look for',
      roleNote: 'We are not a business broker, a lender or a pure adviser. The role we take is agreed per opportunity.',
    },
    focus: {
      h2: 'Where we focus',
      lead: 'These are the sub-sectors and business characteristics we consider. Confirmed thresholds are listed where they exist; anything not yet fixed is marked.',
      sectors: [
        { title: 'Construction and building services', body: 'Businesses where recurring project work and delivery capability are the core.' },
        { title: 'Engineering and design', body: 'Where technical capability and repeatable service models matter.' },
        { title: 'Materials and equipment supply', body: 'Where supply-chain position and margin discipline drive value.' },
        { title: 'Professional services', body: 'Where client relationships and specialist expertise are the asset.' },
      ],
      traits: [
        { dim: 'Client base', what: assumed('client concentration and quality requirements') },
        { dim: 'Capability and people', what: assumed('team / key-technology dependency requirements') },
        { dim: 'Project exposure', what: assumed('project concentration and volatility tolerance') },
        { dim: 'Growth stage', what: assumed('accepted business stage') },
        { dim: 'Financial threshold', what: assumed('revenue / profit / geography / ownership thresholds') },
      ],
      note: 'If your business sits close to this but not inside it, submit a short summary — we will tell you early if it is out of scope.',
    },
    situations: {
      h2: 'Why owners come to us',
      lead: 'Different situations call for different conversations. Pick the one closest to you — it helps us route your enquiry, not to make a decision.',
      items: [
        { title: 'Growth capital', what: 'Funding for expansion, capacity or new geography.', boundary: 'We assess whether growth is supportable, not just intended.' },
        { title: 'Capacity / expansion', what: 'New capability, plant or market entry.', boundary: 'Depends on demand evidence and execution risk.' },
        { title: 'Succession / partial liquidity', what: 'Transition of ownership or a partial exit.', boundary: 'We do not promise a valuation or a completed exit.' },
        { title: 'Strategic partnership', what: 'Shared clients, projects or capabilities.', boundary: 'Non-investment collaboration routes through Contact.' },
        { title: 'Digital / operational improvement', what: 'Systems, data and process change.', boundary: 'Stated as assessment areas until evidence is in place.' },
      ],
      continue: 'Continue with this situation',
      note: '"Other or strategic partnership" is a general conversation, not an investment application.',
    },
    governance: {
      h2: 'Structure and governance',
      lead: 'How much we hold, how we are involved in decisions, and how long we stay are questions we answer per opportunity — not with a single template.',
      rows: [
        { theme: 'Ownership', preference: assumed('equity preference — minority / majority / control'), variable: 'Depends on the situation and the owner\u2019s goals.' },
        { theme: 'Control / governance', preference: assumed('board / key-decision participation'), variable: 'Agreed in the structure, not assumed.' },
        { theme: 'Time horizon', preference: assumed('time horizon'), variable: 'Exit and liquidity expectations are set up front.' },
        { theme: 'Debt / equity', preference: assumed('structure preference'), variable: 'Chosen after we understand the business.' },
      ],
      note: 'We discuss an appropriate structure only after an initial assessment. We do not imply every structure is available for every business.',
    },
    value: {
      eyebrow: 'Beyond capital',
      h2: 'What we might work on together, beyond the money',
      lead: 'Capital is only useful if the business is getting stronger. These are the areas we consider — each listed with its input, possible actions and how we would measure it.',
      rows: [
        { topic: 'Growth systems', input: 'Pipeline, quoting, repeat business.', action: 'Structure sales and delivery processes.', measure: 'Win rate, repeat revenue, delivery margin.' },
        { topic: 'Governance and data', input: 'Reporting, budgeting, controls.', action: 'Introduce disciplined reporting.', measure: 'On-time reporting, decision speed.' },
        { topic: 'Digital / systems', input: 'Software, data, workflows.', action: 'Select and implement fit-for-purpose tools.', measure: 'Cycle time, error rate, data availability.' },
        { topic: 'Project / channel synergy', input: 'Shared clients and projects.', action: 'Connect the business to relevant opportunities.', measure: 'Qualified introductions that convert.' },
        { topic: 'People and execution', input: 'Structure, hiring, delivery.', action: 'Strengthen delivery capability.', measure: 'Retention, utilisation, on-time delivery.' },
      ],
      note: 'Until evidence is in place these are assessment areas, not a proven playbook. Any external expert or network support is disclosed with its relationship and authorisation. ' + assumed('team history / output evidence per topic'),
      cta: 'See who does this work',
    },
    confidentiality: {
      h2: 'How we handle sensitive information',
      lead: 'You should not hand over sensitive detail before you need to. We work in three layers.',
      layers: [
        { title: 'Non-sensitive summary', body: 'What the business does, its scale and what you are considering. Enough for a first read.' },
        { title: 'Detail after mutual agreement', body: 'Financials, customers and contracts — shared only when both sides agree and the purpose is clear.' },
        { title: 'Formal due diligence', body: 'The full information set, under a confidentiality agreement where required.' },
      ],
      notFirst: 'Customer lists, full financials, employee data, source code or trade secrets.',
      cta: 'See what we do with your data',
      note: 'We describe how we handle information; we do not offer an automatic NDA on submission. ' + assumed('whether a standard NDA process exists'),
    },
    process: {
      h2: 'What happens after first contact',
      lead: 'A step-by-step path, with your inputs and our judgement at each point. Either side can stop at any stage.',
      steps: [
        { title: 'Non-sensitive first screen', body: 'You provide a summary; we check fit.' },
        { title: 'Management discussion', body: 'We talk through the business and your goals.' },
        { title: 'Information / commercial review', body: 'We review financials and operations under agreed terms.' },
        { title: 'Structure and governance', body: 'We discuss the shape of a possible involvement.' },
        { title: 'Proceed or stop', body: 'Move to agreement, or stop with reasons.' },
      ],
      note: 'Non-investment strategic collaboration diverts to our Contact path after the first screen.',
      cta: 'See the shared method',
    },
    faq: {
      h2: 'Questions owners ask',
      items: [
        { q: 'Will you take control of my business?', a: 'Not by default. Ownership and control are agreed per opportunity — we will tell you the range we can work within. ' + assumed('control preference') },
        { q: 'How confidential is the first conversation?', a: 'We ask only for a non-sensitive summary first. Detail is shared later, under agreed terms.' },
        { q: "Do you pay advisers' or brokers' fees?", a: assumed('intermediary / commission policy') },
        { q: 'Is this a loan?', a: 'No. We look at business investment and partnership opportunities, not lending. ' + assumed('deal-type boundary') },
        { q: "What if I'm not ready to sell, just exploring?", a: 'That is fine. A first conversation is about fit, not a commitment by either side.' },
      ],
      cta: 'Submit a business opportunity',
      alt: 'Discuss a partnership',
      siblings: ['Property Development', 'Innovation & Ventures'],
    },
  },

  innovation: {
    meta: {
      title: 'Innovation & Ventures | Cyberate Investments',
      description:
        'The innovation themes, readiness and evidence we look for in PropTech, construction tech, AI and sustainable construction — and the difference between investment and pilot.',
    },
    hero: {
      eyebrow: 'Innovation & Ventures',
      h1: 'We look at innovation that solves measurable built-environment problems.',
      lead:
        'If you are building technology or materials for how we plan, design, build or operate the built environment, this page sets out the themes we consider, the evidence we need, and the difference between investment and a pilot.',
      boundary: 'We evaluate strategic collaboration and selected opportunities. This is a stated focus — not an existing venture portfolio or a claim of proprietary AI capability. ' + assumed('innovation pillar mandate, stage, geography'),
      cta: 'Submit an innovation opportunity',
      seeCriteria: 'See the themes',
    },
    themes: {
      h2: 'Themes we care about',
      lead: 'We start from a real problem, not a technology. Each theme below lists the problem, example technologies and the result we would expect to measure.',
      rows: [
        { problem: 'Cost and schedule', tech: 'Planning and estimating tools, schedule analytics.', result: 'Reduced cost or time overrun on a real project.' },
        { problem: 'Quality and risk', tech: 'Inspection, defect and compliance tools.', result: 'Fewer defects or rework, faster sign-off.' },
        { problem: 'Design and planning', tech: 'Generative or simulation tools for design options.', result: 'Faster, better-evaluated design decisions.' },
        { problem: 'Operations and maintenance', tech: 'Asset, energy and maintenance platforms.', result: 'Lower operating cost or downtime.' },
        { problem: 'Carbon and materials', tech: 'Low-carbon materials, waste reduction, tracking.', result: 'Measured embodied or operational carbon reduction.' },
      ],
      exclude: 'General-purpose SaaS with no built-environment application is out of scope. ' + assumed('exclusion list finalisation'),
    },
    readiness: {
      h2: 'How ready do you need to be?',
      lead: 'We accept different stages for investment versus pilot collaboration. Each level below shows the evidence expected and whether we currently consider it.',
      rows: [
        { stage: 'Problem and interviews', evidence: 'Documented problem, users, willingness to pay.', invest: 'Not yet', pilot: 'Possibly, for validation' },
        { stage: 'Prototype / technical validation', evidence: 'Working prototype, technical tests.', invest: 'Not yet', pilot: 'Possibly' },
        { stage: 'Pilot with data', evidence: 'Deployment results from a real site or project.', invest: assumed('investment threshold'), pilot: 'Yes' },
        { stage: 'Paying customers', evidence: 'Usage, retention, unit economics.', invest: assumed('investment threshold'), pilot: 'Yes' },
        { stage: 'Scaling', evidence: 'Repeatable delivery and margin evidence.', invest: assumed('investment threshold'), pilot: 'Yes' },
      ],
      note: 'Advancing a stage is not automatic. We may stop or return you to an earlier question at any point.',
    },
    validation: {
      eyebrow: 'Validation',
      h2: 'How we separate a good demo from deployable value',
      lead: 'A polished demo is not evidence. We assess these dimensions, and we ask for proof against each.',
      rows: [
        { dim: 'Problem strength', what: 'Is the problem real, frequent and worth solving?', evidence: 'Customer interviews, purchase intent.' },
        { dim: 'Deployment environment', what: 'Does it work on a real site, not a sandbox?', evidence: 'Pilot results, uptime, integration notes.' },
        { dim: 'Integration', what: 'Does it fit existing workflows and systems?', evidence: 'Integrations, API docs, user adoption.' },
        { dim: 'Safety / compliance', what: 'Does it meet applicable standards and regulation?', evidence: 'Certifications, test reports, audits.' },
        { dim: 'Adopter evidence', what: 'Who actually uses it, and do they stay?', evidence: 'Usage data, retention, references.' },
        { dim: 'Economics', what: 'Does it save or make money at a supportable margin?', evidence: 'Unit economics, cost comparison.' },
        { dim: 'Scalability', what: 'Can it grow without breaking?', evidence: 'Architecture, deployment history.' },
      ],
      ai: 'For AI-based claims we ask about data rights, bias and explainability or human oversight — not just accuracy.',
    },
    pathways: {
      h2: 'What we might actually do',
      lead: 'Capital, pilot and referral are different commitments. The table shows the purpose, the precondition and what we do not promise.',
      rows: [
        { path: 'Investment', precondition: assumed('investment criteria and capital structure'), role: 'Capital agreed for a specific opportunity after assessment.', notPromise: 'A valuation, a round, or follow-on funding.' },
        { path: 'Pilot / deployment', precondition: 'A real site or project where it fits.', role: 'Access to a relevant trial, with agreed scope.', notPromise: 'A commercial contract or rollout.' },
        { path: 'Strategic collaboration', precondition: 'Mutual value beyond a transaction.', role: 'Shared work on a defined problem.', notPromise: 'Exclusivity or a commitment.' },
        { path: 'Referral / network', precondition: assumed('referrable parties and authorisation'), role: 'Introductions where we have an authorised relationship.', notPromise: 'A guaranteed customer or channel.' },
      ],
      note: 'We do not promise customers, channels or projects through our network. Any introduction is made only where a relationship is authorised and disclosed.',
      cta: 'See how roles are defined',
    },
    materials: {
      h2: 'What to include in a first submission',
      lead: 'A one-page summary is enough to start. Do not send source code, trade secrets or customer data in the first step.',
      minimum: ['Problem and who has it', 'Product and how it works', 'Stage and evidence (pilots, usage, tests)', 'Team and relevant experience', 'What you are asking for'],
      later: ['Demo, data room, references', 'Technical documentation', 'Commercial terms'],
      privacy: 'Send a non-sensitive summary first. We will arrange a secure channel for anything confidential.',
      cta: 'Submit a summary',
    },
    process: {
      h2: 'What happens after you submit',
      lead: 'Relevance first, then evidence, then a decision on pilot or investment.',
      steps: [
        { title: 'Theme screen', body: 'We check the problem and theme fit.', io: 'You provide the summary.' },
        { title: 'Evidence review', body: 'We review pilots, usage and tests.', io: 'You provide evidence and answer questions.' },
        { title: 'Technical / commercial discussion', body: 'We talk through deployment, integration and economics.', io: 'Both sides assess fit.' },
        { title: 'Pathway decision', body: 'Investment, pilot, collaboration or referral — or stop.', io: 'Decided on the evidence.' },
      ],
      note: 'We do not guarantee a pilot, funding or a commercial contract. The depth of feedback we give on a decline depends on our internal process. ' + assumed('feedback depth and recipient'),
      cta: 'See the full approach',
    },
    faq: {
      h2: 'Questions founders ask',
      items: [
        { q: 'Do I need to share my source code?', a: 'No. Send a non-sensitive summary first. Any technical detail is shared later through a secure channel.' },
        { q: 'Do you sign an NDA before the first meeting?', a: 'Not automatically. We ask for a non-sensitive summary first; a confidentiality agreement can follow where it is needed. ' + assumed('NDA process') },
        { q: 'Do you only back AI?', a: 'No. We look at anything that solves a measurable built-environment problem — software, hardware or materials.' },
        { q: 'Can you guarantee a pilot or a customer?', a: 'No. A pilot depends on a real site and fit; a customer is never guaranteed through our network.' },
        { q: 'Is this an accelerator?', a: 'No. This is a focused investment and collaboration assessment, not a cohort program.' },
      ],
      cta: 'Submit an innovation opportunity',
      alt: 'Discuss a partnership',
      siblings: ['Property Development', 'Built Environment Investments'],
    },
  },

  approach: {
    meta: {
      title: 'How We Invest | Cyberate Investments',
      description:
        'Our investment method: the five stages we work through, the gates we apply, the roles we take and the evidence behind each capability — plus where we stop.',
    },
    hero: {
      eyebrow: 'How we invest',
      h1: 'A defined method, not a set of slogans.',
      lead: 'We work through five stages — Identify, Invest, Build, Scale, Realise — each with its own inputs, judgement, our role and the conditions under which we stop.',
      stages: ['Identify', 'Invest', 'Build', 'Scale', 'Realise'],
      boundary: 'Not every opportunity reaches the next stage, and we do not take every role in every project. This method is our operating model, not a guarantee of an outcome. ' + assumed('whether the method operates as an established capability'),
      cta: 'Submit an opportunity',
      discuss: 'Discuss a partnership',
    },
    gates: {
      h2: 'The gates every opportunity must pass',
      lead: 'These apply across property, business and innovation. Each gate has a pass signal and a stop signal.',
      rows: [
        { gate: 'Theme match', evidence: 'Fits a stated pillar and its criteria.', stop: 'Outside our stated focus or exclusions.' },
        { gate: 'Evidence quality', evidence: 'Claims backed by source and date.', stop: 'Unverifiable numbers or missing basis.' },
        { gate: 'Role fit', evidence: 'A role we can actually take.', stop: 'We can only do what we are not set up for.' },
        { gate: 'Risk and compliance', evidence: 'Risk understood and within our boundary.', stop: 'Risk we cannot assess or accept.' },
        { gate: 'Value creation', evidence: 'A clear path to value we can contribute to.', stop: 'No realistic basis for value creation.' },
        { gate: 'Alignment', evidence: 'Mutual goals and a workable timeline.', stop: 'Conflicting objectives or terms.' },
      ],
      links: [
        { label: 'Property criteria', to: '/property-development#property-fit' },
        { label: 'Business criteria', to: '/built-environment-investments#built-focus' },
        { label: 'Innovation themes', to: '/innovation-ventures#innovation-themes' },
      ],
    },
    stages: {
      h2: 'The five stages',
      lead: 'For each stage: the inputs, the key judgement, the role we might play and the conditions to continue or stop.',
      items: [
        {
          name: 'Identify',
          input: 'The opportunity summary — location, stage, evidence, what you want from us.',
          judgement: 'Does it fit a pillar and pass the common gates?',
          role: 'We screen and give a first read.',
          continue: 'Fit is confirmed and we can see a path.',
          stop: 'Theme, evidence or role fit fails.',
        },
        {
          name: 'Invest',
          input: 'The detail needed to decide — feasibility, financials, plans, tests.',
          judgement: 'Is this worth committing capital or a formal role to?',
          role: 'Assessment and, where agreed, a capital or participation decision.',
          note: '"Invest" means the decision point — not a promise that capital is committed.',
          stop: 'The case does not hold under scrutiny.',
        },
        {
          name: 'Build',
          input: 'The agreed structure, plan and responsibilities.',
          judgement: 'Can we deliver the value we committed to?',
          role: 'The role agreed for this opportunity — not "we build everything".',
          note: '"Build" means executing the plan; it does not mean Cyberate is the builder.',
          stop: 'Delivery risk or divergence from the plan emerges and cannot be corrected.',
        },
        {
          name: 'Scale',
          input: 'Evidence the model works and can grow.',
          judgement: 'Is growth repeatable and funded on its own merits?',
          role: 'Support where it fits the role we hold.',
          note: '"Scale" does not guarantee growth.',
          stop: 'The basis for scaling is not demonstrable.',
        },
        {
          name: 'Realise',
          input: 'The agreed exit, return or completion path.',
          judgement: 'Has the value been realised, or is it time to hold or stop?',
          role: 'Work the agreed path.',
          note: '"Realise" does not guarantee an exit or a return. ' + assumed('Realise definition and meaning'),
          stop: 'Conditions change and the agreed path no longer applies.',
        },
      ],
      risk: 'Opportunities can skip, return to an earlier stage, or stop at any point.',
    },
    roles: {
      h2: 'Who does what',
      lead: 'We take a defined role; you and, where relevant, external advisers take others. This table prevents a "one-stop" misreading.',
      rows: [
        { party: 'Cyberate', responsible: 'Assessment, agreed capital or role, support within scope.', decisions: 'Decisions on our own participation.', notResponsible: 'Outcomes we have not agreed to control.' },
        { party: 'Opportunity owner', responsible: 'Information, the asset or business, delivery.', decisions: 'Decisions on the asset or business.', notResponsible: 'Work we have not agreed to do.' },
        { party: 'External advisers', responsible: 'Legal, tax, technical or other specialist input.', decisions: 'Advice within their remit.', notResponsible: 'Decisions that belong to the parties.' },
      ],
      note: 'External advisers and network partners are only referenced where a relationship is authorised and its type is stated. ' + assumed('external network relationships'),
    },
    capabilities: {
      h2: 'Our capabilities, and the evidence behind them',
      lead: 'Five capabilities frame what we bring. Each is stated with the evidence it requires — a capability without evidence is a label, not a fact.',
      rows: [
        { cap: 'Capital', behaviour: 'Participation in an agreed structure.', evidence: 'Structure, source and terms of our capital.', forbidden: '"AUM", "managed funds", public fundraising.' },
        { cap: 'Expertise', behaviour: 'Assessments and decisions we have made.', evidence: 'Team history, project roles, outputs.', forbidden: '"Years of experience" with no record.' },
        { cap: 'Network', behaviour: 'Authorised, typed relationships.', evidence: 'Named relationships with permission.', forbidden: 'Logo walls, untyped partnerships.' },
        { cap: 'Technology', behaviour: 'Methods and tools we actually use.', evidence: 'Real models, methods, outputs.', forbidden: '"AI-driven", "proprietary data" without demo.' },
        { cap: 'Execution', behaviour: 'Responsibility we have carried.', evidence: 'Roles and project facts, with scope.', forbidden: '"One-stop", "full-service guarantee".' },
      ],
      note: 'Evidence status is marked as "confirmed" or "pending" per capability. Most capabilities are currently pending: ' + assumed('publicly available evidence for each capability'),
      cta: 'See the team',
    },
    risk: {
      eyebrow: 'Risk discipline',
      h2: 'How we handle risk and conflict',
      lead: 'We treat risk as part of the decision, not a footnote to it.',
      rows: [
        { risk: 'Planning / regulatory', control: assumed('control approach'), escalate: 'Unresolved planning risk stops the assessment.' },
        { risk: 'Market', control: 'Source-dated market evidence.', escalate: 'Unsupported demand assumption stops the case.' },
        { risk: 'Delivery', control: 'Capability and program review.', escalate: 'Unmanageable delivery risk stops commitment.' },
        { risk: 'Financial', control: 'Feasibility and stress testing.', escalate: 'Case does not hold under stress → stop.' },
        { risk: 'Conflict / related-party', control: 'Disclose relationships and interests.', escalate: assumed('conflict policy and approval authority') },
      ],
      principle: 'We disclose relationships and interests that could affect a decision, and we do not put a transaction ahead of a clear conflict. ' + assumed('governance / conflict policy finalisation'),
      link: 'Read the full boundary',
    },
    byPillar: {
      h2: 'The same method, applied differently',
      lead: 'The five stages are shared; what changes is the main input, the key risk and the value we focus on.',
      columns: [
        {
          pillar: 'Property Development',
          input: 'Site, title, planning, feasibility.',
          risk: 'Planning and delivery.',
          value: 'Getting the project built and realised.',
          material: 'Location, stage, use, scale.',
          to: '/property-development',
          cta: 'See property criteria',
        },
        {
          pillar: 'Built Environment Investments',
          input: 'Business performance, customers, people.',
          risk: 'Concentration and key-person.',
          value: 'Operating and growth systems.',
          material: 'Sub-sector, stage, ownership, motive.',
          to: '/built-environment-investments',
          cta: 'See business criteria',
        },
        {
          pillar: 'Innovation & Ventures',
          input: 'Problem, evidence, deployment.',
          risk: 'Real-world deployment and adoption.',
          value: 'Validation and commercialisation.',
          material: 'Problem, product, stage, evidence.',
          to: '/innovation-ventures',
          cta: 'See innovation themes',
        },
      ],
    },
    finalCta: {
      h2: 'Two ways forward',
      body: 'Have a specific opportunity? Submit it. Want a general or strategic conversation first? Contact us.',
      discuss: 'Discuss a partnership',
      privacy: 'We collect only what we need for a first assessment.',
    },
  },

  about: {
    meta: {
      title: 'About | Cyberate Investments',
      description:
        'Who Cyberate Investments is — our Adelaide base, company details, team and the principles and boundaries behind how we work with partners.',
    },
    hero: {
      eyebrow: 'About',
      h1: 'Cyberate Investments is an Adelaide-based development and investment company.',
      lead: 'We focus on property, built-environment businesses and enabling innovation. This page is where you can verify who we are, who does the work, and the boundaries we work within.',
      boundary: 'Company registration details and any licence or authorisation status are listed below and verified before publication. ' + assumed('final company category and geography'),
      cta: 'See company details',
    },
    entity: {
      h2: 'Company details',
      lead: 'The entity you are dealing with, and where to verify it.',
      fields: [
        { label: 'Legal name', value: entity.name },
        { label: 'ABN', value: entity.abn },
        { label: 'ACN', value: entity.acn },
        { label: 'Principal place of business', value: assumed('principal place of business') },
        { label: 'Registered office', value: assumed('registered office') },
        { label: 'Address (published)', value: entity.address },
        { label: 'Phone', value: entity.phone },
        { label: 'Email', value: entity.email },
        { label: 'Licence / authorisation', value: assumed('AFS licence / authorised representative / exemption / not conducting licensable activity — precise wording') },
        { label: 'Last verified', value: assumed('verification date') },
      ],
      register: assumed('ASIC / ABR official register link'),
      boundary: 'We do not obscure our AFS status. Where an exemption or non-licensable position applies, we use legally approved wording.',
    },
    story: {
      h2: 'Why we focus where we do',
      body: 'We invest in property, businesses and ideas that shape the built environment. That focus comes from one belief: these decisions are made well only when capital, real-world execution and long-term judgement are treated together — not as separate jobs.',
      milestones: assumed('verifiable company milestones and sources'),
    },
    principles: {
      eyebrow: 'How we work together',
      h2: 'The principles behind our decisions',
      lead: 'Each principle is paired with the behaviour you should expect — not an abstract value.',
      items: [
        { title: 'Disciplined before enthusiastic', body: 'We state criteria and risks before we talk about upside.' },
        { title: "An operator's view", body: 'We speak in stages, structures and responsibilities, not generic advice.' },
        { title: 'Restraint over hype', body: 'Short sentences, close evidence, few adjectives.' },
        { title: 'Forward-looking, not trend-chasing', body: 'Technology only matters when it connects to cost, efficiency, risk or a sustainable result.' },
        { title: 'Local and open', body: 'Adelaide and South Australia come first; we claim wider reach only when we can evidence it.' },
      ],
      cta: 'See our risk discipline',
    },
    team: {
      h2: 'The team',
      lead: 'The people currently presented by Cyberate Investments as supporting assessment, operations, business development and market communication. Detailed qualifications and project records can be verified during direct diligence.',
      members: [
        { name: 'William Jiang', role: 'Managing Director & Data Scientist', history: 'Leads investment assessment and brings a data-led approach to property and commercial decisions.', verify: assumed('LinkedIn / professional registration') },
        { name: 'Jax Jin', role: 'Director & Chief Operating Officer, DDDI Group', history: 'Supports group operations, commercial coordination and the execution of cross-functional opportunities.', verify: assumed('LinkedIn / professional registration') },
        { name: 'Gary Gao', role: 'Business Development Manager', history: 'Supports opportunity origination, relationship development and early commercial discussions.', verify: assumed('LinkedIn / professional registration') },
        { name: 'Lin Yuan', role: 'Marketing Manager', history: 'Supports market communication, stakeholder materials and the presentation of investment themes.', verify: assumed('LinkedIn / professional registration') },
      ],
      fallback: 'Team information is available in direct discussion.',
    },
    relationships: {
      h2: 'Relationships and boundaries',
      body: assumed('DDDI entity relationships, brand rights and responsibility boundaries'),
    },
    contactCta: {
      h2: 'Verify, then talk to us',
      cta: 'Discuss a partnership',
      submit: 'Submit an opportunity',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
    },
  },

  contact: {
    meta: {
      title: 'Contact | Cyberate Investments',
      description:
        'Contact Cyberate Investments in Adelaide — phone, email, office address and a short form for general enquiries. For a specific opportunity, use our submission page.',
    },
    hero: {
      eyebrow: 'Contact',
      h1: "Tell us what you need, and we'll route it.",
      lead: 'Two ways in: a general question, or a specific opportunity. Choosing the right one means your message reaches the right person the first time.',
      general: 'Have a general question',
      generalCta: 'See contact details',
      opportunity: 'Have a specific opportunity?',
      opportunityCta: 'Submit an opportunity',
    },
    channels: {
      h2: 'Contact details',
      lead: 'Use the channel that fits your purpose.',
      rows: [
        { channel: 'Phone', value: entity.phone, use: 'Time-sensitive or direct questions.', href: entity.phoneHref },
        { channel: 'Email', value: entity.email, use: 'Written enquiries and documents.', href: entity.emailHref },
        { channel: 'Address', value: entity.address, use: 'Mail and visits.' },
        { channel: 'Entity', value: entity.name, use: 'Formal correspondence.' },
      ],
      hours: assumed('business hours and appointment requirements'),
      verify: 'Verify company details',
    },
    location: {
      h2: 'Finding us',
      visit: assumed('whether walk-ins are accepted or by appointment only'),
      mapAlt: 'Map to 5/15 Field St, Adelaide SA 5000',
      openMaps: 'Open in maps',
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent('5/15 Field St, Adelaide SA 5000'),
      accessibility: assumed('accessibility and parking information'),
    },
    form: {
      h2: 'Send a message',
      lead: 'A short form for general enquiries. Do not send sensitive opportunity detail here — use the submission page instead.',
      fields: {
        name: { label: 'Full name', help: 'Your name, as you would like us to address you.', error: 'Enter your full name.' },
        email: { label: 'Email', help: 'We reply to this address.', error: 'Enter a valid email address.' },
        topic: { label: 'Topic', help: 'Helps route your message.', error: 'Choose a topic.' },
        phone: { label: 'Phone (optional)', help: assumed('whether phone is collected'), error: 'Enter a valid phone number.' },
        message: { label: 'Your message', help: 'A few sentences is enough.', error: 'Tell us how we can help.' },
      },
      topics: ['General enquiry', 'Partnership', 'Media', 'Supplier', 'Other'],
      consent: 'I agree to Cyberate Investments handling my details as described in the Privacy Policy.',
      submit: 'Send message',
      sensitive: 'Please do not include sensitive or confidential material in this form.',
      errorSummary: 'Please fix the highlighted fields and try again.',
      serviceError: "We couldn't send your message. Please try again, or call +61 8 7110 0111.",
      captchaExpired: 'The security check expired. Please complete it again — your message is kept.',
      offline: 'You appear to be offline. Your message is still here; please try again.',
      topicToOpportunity: 'This sounds like a specific opportunity. Consider using our submission form, which asks only for what we need.',
    },
    after: {
      successTitle: 'Message sent',
      successBody: "Thanks — we've received your message. We'll reply to the address you provided. " + assumed('response method and timing; no SLA unless confirmed'),
      reference: 'Your reference:',
      next: 'While you wait, you can review how we invest.',
      call: 'Prefer to call?',
      submitLink: 'Need to submit an opportunity?',
    },
  },

  submit: {
    meta: {
      title: 'Submit an Opportunity | Cyberate Investments',
      description:
        'Submit a property, business, innovation or partnership opportunity to Cyberate Investments. We ask only for what we need for a first assessment.',
    },
    intro: {
      eyebrow: 'Submit an opportunity',
      h1: 'Tell us about your opportunity.',
      lead: 'This form is for a specific property, business, innovation or partnership opportunity. We ask only for what we need to make a first assessment — a short summary, not a data room.',
      notes: [
        { title: 'Initial screen only', body: 'Submitting is a request for a first read, not an application for funding.' },
        { title: 'No commitment either way', body: 'We may ask for more detail or stop; so may you.' },
        { title: 'Minimum information', body: 'We collect the least we need. Do not send sensitive or confidential material yet.' },
      ],
      overview: 'Type → Your details → Opportunity summary → Supporting materials (optional) → Review and submit',
      general: "This isn't a specific opportunity? Contact us instead.",
      sensitive: 'Please do not submit sensitive or confidential material in this step.',
    },
    steps: ['Type', 'Your details', 'Summary', 'Materials', 'Review'],
    type: {
      h2: 'What kind of opportunity is this?',
      lead: 'Choose the closest match. You can change it later.',
      options: [
        { value: 'property', title: 'Property opportunity', example: 'A site or development project.', summary: 'Location, stage, use, scale.' },
        { value: 'business', title: 'Built-environment business', example: 'A building, engineering, design, supply-chain or services business.', summary: 'Sub-sector, stage, ownership, motive.' },
        { value: 'innovation', title: 'Innovation or venture', example: 'A technology, product or venture.', summary: 'Problem, product, stage, evidence.' },
        { value: 'partnership', title: 'Strategic partnership', example: 'A collaboration or joint proposal.', summary: "Both sides' value and proposal." },
        { value: 'other', title: 'Other', example: 'None of the above.', summary: 'Routed to general contact.' },
      ],
      notSure: 'Not sure? Check the criteria',
      error: 'Choose an opportunity type to continue.',
      continue: 'Continue',
    },
    contact: {
      h2: 'Who is submitting this?',
      lead: 'We need to know who we are talking to and that you can speak for this opportunity.',
      fields: {
        name: { label: 'Full name', help: 'Your name.', error: 'Enter your full name.' },
        email: { label: 'Work email', help: 'We reply here.', error: 'Enter a valid email address.' },
        phone: { label: 'Phone', help: assumed('whether required'), error: 'Enter a valid phone number.' },
        organisation: { label: 'Organisation', help: 'Your company or entity, if any.' },
        role: { label: 'Your role', help: 'E.g. owner, director, adviser.' },
        relationship: { label: 'Your relationship to this opportunity', help: 'Owner / authorised representative / adviser', error: 'Tell us your relationship to the opportunity.' },
        preferred: { label: 'Preferred contact', help: 'Email / phone', error: 'Choose how you prefer to be contacted.' },
      },
      relationshipOptions: ['Owner', 'Authorised representative', 'Adviser'],
      preferredOptions: ['Email', 'Phone'],
      adviserNote: 'If you are an adviser or agent, confirm that you are authorised to discuss this opportunity on behalf of the owner.',
      back: 'Back',
      continue: 'Continue',
    },
    details: {
      h2: 'A short summary',
      summary: { label: 'One-line summary', help: 'What the opportunity is, in one sentence.', error: 'Write a one-line summary.' },
      location: { label: 'Location / market', help: 'Where this is.' },
      stage: { label: 'Stage', help: 'How far along it is.' },
      seeking: { label: 'What you want from us', help: 'Capital, co-investment, assessment, collaboration.' },
      unknown: 'Not known yet',
      hint: 'Summaries can be short — a few sentences is enough.',
      back: 'Back',
      continue: 'Continue',
    },
    materials: {
      h2: 'Supporting materials (optional)',
      lead: 'Attachments help us assess faster, but they are optional for a first read.',
      examples: 'Site plans, feasibility summary, business summary, pilot results, or links.',
      limit: assumed('allowed formats and size limits, upload storage and access control'),
      warning: 'Do not attach identity documents, customer data, source code or trade secrets. Send a non-sensitive summary first; we will arrange a secure channel for anything confidential.',
      skip: 'Skip for now — you can provide more later.',
      linksLabel: 'Links or documents (URLs or a short description)',
      linkPlaceholder: 'e.g. a shared link or a one-line description',
      back: 'Back',
      continue: 'Continue',
    },
    review: {
      h2: 'Review and submit',
      edit: 'Edit',
      confirm1: 'I confirm I have authority to share this information and it is accurate to the best of my knowledge.',
      confirm2: 'I agree to Cyberate Investments handling my information as described in the Privacy Policy.',
      noNda: 'Submitting does not create a confidentiality agreement, an offer, or any obligation on either side to proceed.',
      marketing: 'Email me about Cyberate updates (optional).',
      captcha: 'Complete the security check.',
      captchaExpired: 'Security check expired — please complete it again. Your details are kept.',
      submit: 'Submit opportunity',
      error: 'You need to confirm the statements above before submitting.',
      back: 'Back',
    },
    result: {
      successTitle: 'Opportunity submitted',
      successBody: "We've received your summary. We'll review it and reply to the address you provided. " + assumed('response timing and owner'),
      reference: 'Your reference:',
      next: 'While you wait, review our approach.',
      fail: "We couldn't submit your opportunity. Please try again.",
      unknown: "We can't confirm whether this was received. Please wait before resubmitting, or call +61 8 7110 0111.",
      call: 'Prefer to talk?',
      email: 'Email',
      retry: 'Try again',
    },
  },

  privacy: {
    meta: {
      title: 'Privacy Policy | Cyberate Investments',
      description:
        'How Cyberate Investments collects, uses, discloses, retains and protects personal information, and how you can access, correct or delete it.',
    },
    header: {
      eyebrow: 'Privacy Policy',
      h1: 'Privacy Policy',
      controller: entity.name + ' ' + assumed('data controller and ABN/ACN'),
      updated: 'Last updated: ' + assumed('date'),
      scope: 'Applies to this website, our contact and submission forms, and related email and offline interactions.',
      summary: 'In short: we collect only what we need to respond to you or assess an opportunity, we share it only where described below, and you can ask to access or correct it. The full policy follows.',
      notice: 'This page is a privacy-disclosure framework and is not a substitute for legal review. ' + assumed('legal review and finalisation'),
    },
    collection: {
      h2: 'What we collect and where it comes from',
      rows: [
        { scenario: 'Browsing', data: assumed('log / analytics data (if any)'), source: assumed('source'), required: assumed('required') },
        { scenario: 'General contact', data: 'Name, email, topic, message (and phone if collected).', source: 'The contact form.', required: 'Name, email, message.' },
        { scenario: 'Opportunity submission', data: 'Name, contact details, relationship, opportunity summary, optional materials.', source: 'The submission form.', required: 'Marked in the form.' },
        { scenario: 'Files and correspondence', data: 'Attachments and follow-up email.', source: 'Secure channels.', required: 'As needed.' },
      ],
      sensitive: 'If you send sensitive information we did not ask for, we will handle it only as needed to respond, and delete it where we can. ' + assumed('handling approach'),
    },
    use: {
      h2: 'Why we use your information',
      rows: [
        { purpose: 'Respond to enquiries', data: 'Contact details and message.', basis: assumed('legal basis'), consequence: 'We cannot reply.' },
        { purpose: 'Assess opportunities', data: 'Summary and materials.', basis: assumed('legal basis'), consequence: 'We cannot assess.' },
      ],
      marketing: 'We do not send marketing communications unless you separately opt in. We do not use automated decision-making for any significant decision about you. ' + assumed('whether accurate'),
    },
    disclosure: {
      h2: 'Who we share information with',
      rows: [
        { recipient: assumed('email / hosting / form provider'), purpose: 'Deliver the service.', data: assumed('data'), location: assumed('cross-border'), safeguard: assumed('safeguards') },
        { recipient: assumed('captcha provider'), purpose: 'Security check.', data: assumed('data'), location: assumed('cross-border'), safeguard: assumed('safeguards') },
        { recipient: 'Related entities / advisers', purpose: 'Where disclosed and needed.', data: assumed('data'), location: assumed('cross-border'), safeguard: assumed('safeguards') },
        { recipient: 'Legal / regulatory', purpose: 'Where required by law.', data: assumed('data'), location: assumed('cross-border'), safeguard: assumed('safeguards') },
      ],
      note: 'Cross-border disclosure is a publication blocker until confirmed.',
    },
    retention: {
      h2: 'How long we keep information and how we protect it',
      rows: [
        { type: 'Enquiries', term: assumed('period or decision criteria') },
        { type: 'Opportunity submissions', term: assumed('period') },
        { type: 'Uploaded files', term: assumed('period') },
      ],
      security: 'We apply access controls, limit who can see information, and use secure channels for files. No method of transmission is completely secure. ' + assumed('actual organisational / technical measures'),
      incident: 'If an incident affects your information, we will notify you as required.',
    },
    rights: {
      h2: 'Your rights and choices',
      rows: [
        { right: 'Access', how: 'Email us with your request.', limit: 'We verify identity first.' },
        { right: 'Correction', how: 'Tell us what to fix.', limit: '—' },
        { right: 'Deletion', how: 'Ask us to delete where we can.', limit: 'Legal retention may apply.' },
        { right: 'Opt out of marketing', how: 'Use the unsubscribe link.', limit: 'Service messages still apply.' },
      ],
    },
    cookies: {
      h2: 'Cookies, analytics and external links',
      note: assumed('cookie / storage categories from an actual scan'),
      external: 'Links to external sites are governed by their own policies; we are not responsible for how they handle your information.',
    },
    contact: {
      h2: 'Contact, complaints and changes',
      enquiries: 'Privacy enquiries: ' + assumed('dedicated mailbox or contact person'),
      complaints: assumed('internal complaint process and applicable regulator (e.g. OAIC)'),
      updates: 'We may update this policy. The "last updated" date at the top shows when it changed.',
      cta: 'Contact us',
    },
  },

  terms: {
    meta: {
      title: 'Terms & Conditions | Cyberate Investments',
      description:
        'The terms that govern use of the Cyberate Investments website, including the boundary between general information and financial advice, and liability.',
    },
    header: {
      eyebrow: 'Terms & Conditions',
      h1: 'Terms & Conditions',
      entity: entity.name + ' ' + assumed('ABN/ACN'),
      effective: 'Effective: ' + assumed('date'),
      scope: 'These terms govern your use of this website.',
      acceptance: 'By using this website you accept these terms. ' + assumed('acceptance mechanism consistent with the actual UI'),
      notice: 'This page is a terms framework and is not a substitute for legal review. ' + assumed('legal review and finalisation'),
    },
    siteUse: {
      h2: 'Using this website',
      allowed: 'You may browse this website for your own information and, where provided, use our forms to contact us or submit an opportunity.',
      prohibited: 'You must not misuse the website, interfere with its operation, attempt to bypass security, use it for unlawful purposes, or automate access in a way that disrupts the service.',
      availability: 'We aim to keep the website available but do not guarantee uninterrupted access.',
    },
    boundary: {
      h2: 'Important: general information, not financial advice',
      conclusion:
        'Nothing on this website is financial product advice, a recommendation, an offer or invitation to acquire any financial product, or a promise of any return or outcome. We describe opportunities we focus on and the role we may play. Participation, capital, structure and terms are agreed only for a specific opportunity after assessment and, where required, legal and regulatory review.',
      licence: 'Cyberate Investments Pty Ltd ' + assumed('licence / authorisation / exemption / non-licensable activity — precise statement') + '.',
      supplement: 'We do not engage in public fundraising and do not provide personal financial advice to retail clients.',
      riskLink: 'See how we handle risk',
    },
    infoRisk: {
      h2: 'Information, change and risk',
      points: [
        'Information is provided as at its stated date and may change.',
        'Any figure states its scope, basis, period and source; check it before relying on it.',
        'Forward-looking statements are estimates, not guarantees.',
        'Historical performance does not guarantee future results.',
        'Property, business and innovation opportunities carry risk, including loss of capital; you should obtain your own advice.',
      ],
    },
    submissions: {
      h2: 'Submissions',
      points: [
        'You represent that you have authority to share what you submit and that it is accurate to your knowledge.',
        'Submitting information does not create a confidentiality agreement unless we sign one separately.',
        'Submission does not create an investment, advisory or agency relationship.',
        'Submission does not oblige us to review, proceed or respond in any particular way.',
        'Do not submit sensitive, third-party or confidential material in the first step.',
      ],
      warning: 'No NDA is formed by submitting. No obligation to proceed arises.',
      privacyLink: 'How we handle your information',
    },
    intellectualProperty: {
      h2: 'Intellectual property',
      site: 'All content on this website — text, graphics, logo and layout — is owned by or licensed to Cyberate Investments, unless stated otherwise. ' + assumed('actual asset rights'),
      licence: 'You may view and print content for personal, non-commercial reference. You may not otherwise reproduce or distribute it.',
      thirdParty: 'Third-party names and marks belong to their owners.',
      submitted: 'You retain ownership of what you submit; by submitting you grant us a limited right to use it to assess and respond to your opportunity. ' + assumed('licence scope confirmed by counsel'),
    },
    thirdParties: {
      h2: 'Third-party links and services',
      points: [
        'External links are provided for convenience; we do not control and are not responsible for their content or privacy practices.',
        'A link or mention does not by itself mean an endorsement or partnership.',
        'Where a relationship exists, it is stated with its type.',
      ],
    },
    liability: {
      h2: 'Warranties and liability',
      points: [
        'To the extent permitted by law, the website is provided without warranties.',
        'To the extent permitted by law, Cyberate Investments is not liable for loss arising from use of, or reliance on, this website.',
        'Nothing in these terms excludes rights you cannot be excluded by law.',
      ],
    },
    lawContact: {
      h2: 'Governing law, changes and contact',
      law: 'These terms are governed by the laws of South Australia, Australia. ' + assumed('governing law confirmation'),
      updates: 'We may update these terms. The effective date at the top shows when they changed.',
      contact: 'Questions about these terms: ' + entity.email,
      severability: 'If any provision is unenforceable, the remainder continues.',
    },
  },

  notfound: {
    meta: {
      title: 'Page not found | Cyberate Investments',
      description: 'The page you were looking for could not be found. Return to the Cyberate Investments home page or explore our investment areas.',
    },
    eyebrow: '404',
    h1: 'Page not found',
    body: 'The page you\u2019re looking for may have moved, or the address may be incorrect.',
    cta: 'Back to home',
    services: 'Looking for our services? They now live under How We Invest.',
    links: [
      { label: 'Property Development', to: '/property-development' },
      { label: 'Built Environment Investments', to: '/built-environment-investments' },
      { label: 'Innovation & Ventures', to: '/innovation-ventures' },
      { label: 'How We Invest', to: '/approach' },
      { label: 'About', to: '/about' },
      { label: 'Contact', to: '/contact' },
    ],
    help: {
      h2: "Still can't find it?",
      body: 'If you followed a link here, let us know — or, if you have a specific opportunity, submit it directly.',
      contact: 'Contact us',
      submit: 'Submit an opportunity',
      warning: 'Do not enter sensitive information on this page.',
    },
  },

  breadcrumb: {
    home: 'Home',
  },
};

export default en;
